import axios from "axios";
import { headers } from "../exports/exports";
import { dynamicFailed } from "../hooks/useToast";

export const fetchEventBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-events-banners?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error) {
    dynamicFailed("Server Error");
  }
};

export const fetchEventData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_strapiUrl}/api/frcsit-events-events?sort=From_Date:desc&populate=*`,
        { headers }
      );
      return response.data.data;
    } catch (error) {
      dynamicFailed("Server Error");
    }
  };